import * as React from 'react';
import { OnlyOnPrint, PrintStyle } from '../../designSystem/compositeComponents/Print';

type PrintWrapperProps = {
    innerRef: React.Ref<HTMLDivElement>,
    children: React.ReactNode
}
export function PrintWrapper(props:PrintWrapperProps):JSX.Element
{
    return (
        <OnlyOnPrint>
            <PrintStyle ref={props.innerRef}>
                {props.children}
            </PrintStyle>
        </OnlyOnPrint>
    );
}